import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Row, Col,Grid } from 'react-bootstrap'
import NKIcon from '@norkart/ikoner'

import './innstillinger.css'

export default class Innstillinger extends Component {
  
    render() {
        return (
        
            <div className="listeContainer">
                <h2>Brukerinnstillinger </h2>
                <Grid>
                <Row>
                    <Col key="maalere" sm={6} xs={12}>
                        <Link to={`${this.props.match.url}/maalere/`} className="list-group-item marginTop10">
                            <div style={{ float: 'right', overflow: 'hidden' }}>
                                <NKIcon icon="hoyrepil" color="nk-black" size="2" />
                            </div>
                            <div style={{ float: 'left', overflow: 'hidden' }}>
                                <strong>Forhåndsdefinerte målere</strong>
                                <br />
                                <p>Oppsett av forhåndsdefinerte målere</p>
                            </div>
                            <div style={{ float: 'none', clear: 'both' }} />
                        </Link>
                    </Col>
                    <Col key="sms" sm={6} xs={12}>
                        <Link to={`${this.props.match.url}/sms/`} className=" list-group-item marginTop10">
                            <div style={{ float: 'right', overflow: 'hidden' }}>
                                <NKIcon icon="hoyrepil" color="nk-black" size="2" />
                            </div>
                            <div style={{ float: 'left', overflow: 'hidden' }}>
                                <strong>SMS</strong>
                                <br />
                                <p>Oppsett av smsmal</p>
                            </div>
                            <div style={{ float: 'none', clear: 'both' }} />
                        </Link>
                    </Col>
                </Row>
                <Row>
                    <Col key="sms" sm={6} xs={12}>
                        <Link
                            to={`${this.props.match.url}/arbeidslister/`}
                            className=" list-group-item marginTop10"
                        >
                            <div style={{ float: 'right', overflow: 'hidden' }}>
                                <NKIcon icon="hoyrepil" color="nk-black" size="2" />
                            </div>
                            <div style={{ float: 'left', overflow: 'hidden' }}>
                                <strong>Arbeidslister</strong>
                                <br />
                                <p>Oppsett av tidspunkter</p>
                            </div>
                            <div style={{ float: 'none', clear: 'both' }} />
                        </Link>
                    </Col>
                </Row>
              
            </Grid>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/innstillinger/innstillinger.jsx